import { FulfillmentChannelOrderRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class FulfillmentChannelOrderService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentChannelOrderRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default FulfillmentChannelOrderService;



// WEBPACK FOOTER //
// ./src/common/data/services/FulfillmentChannelOrderService.js